export enum DIALOG_CLASSNAME {
  CONTAINER = 'v-dialog-container',
  BACKDROP = 'v-dialog-backdrop',
  MAIN = 'v-dialog-main',
}

export enum DIALOG_EVENT_TYPE {
  HIDE = 'hide',
  HIDDEN = 'hidden',
  SHOW = 'show',
  SHOWN = 'shown',
}

export enum DIALOG_TRIGGER {
  BACKDROP = 'backdrop',
  ESC = 'esc',
}

export enum DIALOG_CONTAINER_POSITION {
  TOP_LEFT = 'top-left',
  TOP = 'top',
  TOP_RIGHT = 'top-right',
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM = 'bottom',
  BOTTOM_RIGHT = 'bottom-right',
}

export enum INITIAL_Z_INDEX {
  DRAWER = 2000,
  MODAL = 3000,
}
